import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import axios from "axios";

import Tesseract from 'tesseract.js';
import PhoneInput from 'react-phone-input-2';
// import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
// import { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-input-2/lib/style.css';


import { domainUrl } from '../../data/dummyData';
import CountryStateCityPicker from '../../components/CountryStateCityPicker';

import { parse, isValid, format } from 'date-fns'; // Ensure you have date-fns installed
import stringSimilarity from 'string-similarity';

import { SUPPORTED_COUNTRIES, SUPPORTED_STATES, SUPPORTED_CITIES, } from "../../data/langData";

export default function RegisterPage() {

    const navigate = useNavigate();

    useEffect(() => {
        const userToken = localStorage.getItem('userToken')
        ? localStorage.getItem('userToken')
        : null
        if (userToken !== null) {
          navigate('/')
          // return navigateToRoute('login')
          // window.location.href = "/login";
          // return null
        }
    }, [])

    const [usernameStatus, setUsernameStatus] = useState(null);
    const [formData, setFormData] = useState({
        eid: '',
        dob: '',
        email: '',
        emy_code: '',
        country: '',
        password_confirmation: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        phone: '',
        password: '',
        state: '',
        city: '',
        lat: '',
        long: '',
        idImage: null,
    });

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(
        (pos) => {
            setFormData({ ...formData, long: pos.coords.longitude, lat: pos.coords.latitude });
            // setLocation({
            // lat: pos.coords.latitude,
            // long: pos.coords.longitude,
            // });
        },
        (err) => console.warn('Geolocation error:', err)
        );

        if (formData.first_name && formData.last_name) {
            const suggestion = `${formData.first_name.toLowerCase()}_${formData.last_name.toLowerCase()}`;
            checkUsername(suggestion);
        }
    }, [formData.first_name, formData.last_name]);

    const [ocrText, setOcrText] = useState('');
    const [idImage, setIdImage] = useState(null);
    const [cardImage, setCardImage] = useState(null);
    const [matchError, setMatchError] = useState('');

    const [ocrPassed, setOcrPassed] = useState(false);
    const [ocrMsg, setOcrMsg] = useState('');

    const [phoneCountry, setPhoneCountry] = useState('us');
    const countryToLang = {
        cn: 'chi_sim',    // China → Simplified
        sg: 'chi_sim',    // Singapore → Simplified
        tw: 'chi_tra',    // Taiwan → Traditional
        hk: 'chi_tra',    // Hong Kong → Traditional
        mo: 'chi_tra',    // Macau → Traditional
        jp: 'jpn',        // Japan
        kr: 'kor',        // Korea
        ru: 'rus',        // Russia
        sa: 'ara',        // Saudi Arabia → Arabic
        ir: 'fas',        // Iran → Persian
        in: 'hin',        // India → Hindi (fallback to eng if unsure)
        fr: 'fra',        // France
        de: 'deu',        // Germany
        es: 'spa',        // Spain
        ng: 'eng',        // Nigeria
        us: 'eng',        // United States
        gb: 'eng',        // United Kingdom
        // fallback default
        default: 'eng',
    };

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const url = URL.createObjectURL(file);
            setIdImage(url);       // for OCR + preview
            setCardImage(file);    // real file for uploading
            runOCR(url);           // blob URL is fine for OCR
        }
    };

    const [detectedFields, setDetectedFields] = useState({});

    const getOCRLang = (countryCode) => {
        return countryToLang[countryCode?.toLowerCase()] || countryToLang.default;
    };
      
    const runOCR = (imageUrl) => {
        const lang = getOCRLang(phoneCountry); // phoneCountry set from PhoneCountryPicker
        Tesseract.recognize(imageUrl, lang).then(({ data: { text } }) => {
          setOcrText(text);
          validateOCR(text);
        });
    };

    const extractDateFromText = (text) => {
        const regex = /(\d{2}[-\/\sA-Z]{1,3}\d{2,4}[-\/\sA-Z]{1,3}\d{2,4})/gi;
        const match = regex.exec(text);
        return match ? match[1] : null;
      };

    const cleanText = (str) =>
        str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")     // Remove accents
          .replace(/[^\w\s]/g, "")             // Remove punctuation
          .replace(/\s+/g, " ")                // Normalize whitespace
          .toLowerCase();

    const isFuzzyMatch = (needle, haystack, threshold = 0.7) => {
        const cleanedNeedle = cleanText(needle);
        const cleanedHaystack = cleanText(haystack);
        
        if (cleanedHaystack.includes(cleanedNeedle)) return true;
        
        const matches = cleanedHaystack
            .split(/\s+/)
            .map(word => stringSimilarity.compareTwoStrings(cleanedNeedle, word));
        
        return Math.max(...matches) >= threshold;
    };

    const extractDOBFromMRZ = (text) => {
        const mrzMatch = text.match(/[A-Z0-9<]{10,}\n[A-Z0-9<]{10,}/); // Match 2-line MRZ
        if (!mrzMatch) return null;
        const mrz = mrzMatch[0].replace(/\n/g, '');
        const dobRaw = mrz.slice(13, 19); // YYMMDD
        const dobParsed = parse(dobRaw, 'yyMMdd', new Date());
        return isValid(dobParsed) ? format(dobParsed, 'yyyy-MM-dd') : null;
    };

    const countryDateFormats = {
        'China': ['yyyy-MM-dd'],
        'US': ['MM/dd/yyyy'],
        'UK': ['dd/MM/yyyy'],
        'Germany': ['dd.MM.yyyy'],
        'India': ['dd-MM-yyyy'],
        'Ghana': ['dd/MM/yyyy', 'dd-MM-yyyy'],
        'Nigeria': ['dd/MM/yyyy', 'dd-MM-yyyy'],
        // Add more countries here
    };

    const validateOCR = (text, data = formData) => {
        const lowerText = cleanText(text); // Use cleaned text for matching

        setOcrPassed(false);
        setOcrMsg('Validating Data...')
    
        const parseDateForCountry = (dateStr, country) => {
            const formats = countryDateFormats[country] || ['dd/MM/yyyy', 'yyyy-MM-dd'];
            for (let fmt of formats) {
                const parsed = parse(dateStr, fmt, new Date());
                if (isValid(parsed)) return format(parsed, 'yyyy-MM-dd');
            }
            return null;
        };
    
        // Use form data DOB or fallback to extracted date from raw text
        let parsedDOB = parseDateForCountry(data.dob, data.country);
        if (!parsedDOB) {
            const rawDOB = extractDateFromText(text);
            parsedDOB = rawDOB ? parseDateForCountry(rawDOB, data.country) : null;
        }
        if (!parsedDOB) {
            parsedDOB = extractDOBFromMRZ(text) || extractDateFromText(text);
        }
    
        const results = {
            first_name: isFuzzyMatch(data.first_name, text),
            middle_name: data.middle_name ? isFuzzyMatch(data.middle_name, text) : true,
            last_name: isFuzzyMatch(data.last_name, text),
            eid: isFuzzyMatch(data.eid, text),
            dob: parsedDOB ? isFuzzyMatch(parsedDOB, text) : false,
            country: isFuzzyMatch(data.country, text),
            city: isFuzzyMatch(data.city, text),
            // nationality: /nationality[\s:]*[a-z]+/i.test(lowerText),
            // id_type: /(passport|voter|driver|national)/i.test(lowerText),
        };
    
        const passed = [];
        const failed = [];
    
        for (let [key, matched] of Object.entries(results)) {
            const expected = ['nationality', 'id_type'].includes(key)
                ? `matches ${key} regex`
                : key === 'dob' ? parsedDOB : data[key];
    
            const actual = key === 'dob' ? parsedDOB : data[key];
    
            (matched ? passed : failed).push({ field: key, expected, actual });
        }
    
        const allowSubmission = (
            (results.first_name && results.dob && results.country) ||
            passed.length >= 3 ||
            passed.length > failed.length
        );
    
        if (!allowSubmission) {
            setMatchError(`Mismatch in: ${failed.map(f => f.field).join(', ')}`);
            setOcrPassed(false);
            setOcrMsg('Sorry Please Retake/Upload a Clearer ID card Image and Always Fill All Fields Above First!!!')
        } else {
            setOcrPassed(true);
            setOcrMsg('')
            setMatchError('');
        }

        // const requiredFields = ['first_name', 'last_name', 'eid', 'dob', 'country', 'city', 'nationality', 'id_type'];
        // const matchedFields = passed.map(f => f.field);
        // const matchedCount = requiredFields.filter(f => matchedFields.includes(f)).length;

        // const allowSubmission = matchedCount / requiredFields.length >= 0.5;
    
        // console.log('Passed fields:', passed);
        // console.log('Failed fields:', failed);
        // console.log('Parsed DOB:', parsedDOB);
        // console.log('OCR Raw Text:', text);
        // console.log('Form Data:', data);
    };

    const checkUsername = async (value) => {
        if (!/^[A-Za-z0-9_\-@]+$/.test(value)) {
            setUsernameStatus({ available: false, message: "Only letters, numbers, _, -, @ allowed" });
            return;
        }

        if (value?.length < 3) {
            setUsernameStatus({ available: false, message: "Username must be more than 3 digits" });
            return;
        }
    
        try {
            const { data } = await axios.post(`${domainUrl}/check-username`, { 
              username:value,
              lat: formData?.lat,
              long: formData?.long, 
            });

            // const data = await res.json();
            setUsernameStatus(data);
            if (data.available) {
                setFormData(prev => ({ ...prev, emy_code: value }));
            }
      
            // if (data.success) {
            //   setForm(data.form);
            //   setKeyRequired(false);
            // } else {
            //   setError(data.message);
            // }
        } catch (err) {
            console.error('Error checking username', err);
        }

    };

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'idImage') {
            setFormData({ ...formData, idImage: files[0] });
        } else {
            setFormData({ ...formData, [name]: value });

            if (ocrText) {
                validateOCR(ocrText, { ...formData, [name]: value });
            }
        }
    };

    const handlePhoneChange = (value) => {
        // if (isValidPhoneNumber(value)) {
        //   setFormData((prev) => ({
        //     ...prev,
        //     phone: value
        //   }));
        // } else {
        //   console.log("Invalid phone number");
        // }

        setFormData((prev) => ({
            ...prev,
            phone: value
        }));
    };


    const isStrongPassword = (password) => {
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^])[A-Za-z\d@$!%*?&#^]{8,}$/.test(password);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (formData.password !== formData.password_confirmation) {
            alert("Passwords do not match!");
            return;
        }
    
        if (!isStrongPassword(formData.password)) {
            alert("Password must be at least 8 characters and include uppercase, lowercase, number, and special character.");
            return;
        }
    
        if (!ocrPassed) {
            alert("OCR validation failed. Please check the uploaded ID.");
            return;
        }
    
        const form = new FormData();
        for (const key in formData) {
            form.append(key, formData[key]);
        }
        form.append('ocr_text', ocrText);
        
        form.append('ocr_text', ocrText);

        if (cardImage) {
            form.append('id_image', cardImage);  // actual file
        }
    
        try {
            const { data } = await axios.post(`${domainUrl}/register`, form);
            
            // console.log('data', data)
            if (!data.success) {
                console.error(data.errors);
                alert('Error: ' + JSON.stringify(data.errors));
            } else {
                navigate('/login');
                alert('User registered successfully!');
                setFormData({
                    eid: '', dob: '', email: '', emy_code: '', country: '',
                    first_name: '', last_name: '', middle_name: '',
                    phone: '', password: '', password_confirmation: '',
                    state: '', city: '', lat: '', long: '', idImage: null,
                });
            }
        } catch (error) {
            if (error.response) {
                // console.error("Backend responded with an error:");
                // console.error("Status:", error.response.status);
                // console.error("Data:", error.response.data);
                alert("Error: " + JSON.stringify(error.response.data.message || error.response.data));
            } else if (error.request) {
                // console.error("No response received from server:");
                alert("Error: No response received from server" );
                // console.error(error.request);
            } else {
                // console.error("Error setting up request:");
                alert("Error: Error setting up request" );
                // console.error(error.message);
            }
        }
    };

    return (
        <>
            <Header page="register" />
            <div className="container-fluid contact py-5">
                <div className="container py-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="form-section bg-success p-5">
                                <h1 className="display-4 text-white mb-4">Register</h1>

                                {/* {Object.keys(detectedFields).length > 0 && (
                                    <div className="bg-white p-3 my-3 rounded shadow-sm text-white">
                                        <h5>Detected from ID:</h5>
                                        <ul>
                                            {Object.entries(detectedFields).map(([key, value]) => (
                                                <li key={key}><strong>{key.replace('_', ' ')}:</strong> {value}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )} */}

                                <form onSubmit={handleSubmit}>
                                    <div className="row g-4">

                                        <div className="col-md-6">
                                            <div className="form-floating form-section-col">
                                                <input type="text" className="form-control border-0" name="first_name" placeholder="First Name" onChange={handleChange} required />
                                                <label htmlFor="first_name">First Name</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating form-section-col">
                                                <input type="text" className="form-control border-0" name="last_name" placeholder="Last Name" onChange={handleChange} required />
                                                <label htmlFor="last_name">Last Name</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating form-section-col">
                                                <input type="text" className="form-control border-0" name="middle_name" placeholder="Middle Name" onChange={handleChange} />
                                                <label htmlFor="middle_name">Middle Name</label>
                                            </div>
                                        </div>
                                        

                                        <div className="col-md-6">
                                            <div className="form-floating form-section-col">
                                                <input type="text" className="form-control border-0" name="eid" placeholder="EID Number" onChange={handleChange} required />
                                                <label htmlFor="eid">ID Number</label>
                                            </div>
                                        </div>

                                        <CountryStateCityPicker
                                            value={{
                                                country: formData.country,
                                                state: formData.state,
                                                city: formData.city
                                            }}
                                            onChange={(name, val) =>
                                                setFormData((prev) => ({
                                                ...prev,
                                                [name]: val,
                                                }))
                                            }

                                            supportedCountries= {SUPPORTED_COUNTRIES}
                                            supportedStates={SUPPORTED_STATES}
                                            supportedCities={SUPPORTED_CITIES}

                                            onLanguageDetect={(lang) => {
                                                console.log("Switching to language:", lang);
                                                setDetectedFields(lang);
                                                // i18n.changeLanguage(lang); // optional
                                            }}
                                        />


                                        <div className="col-md-6">
                                            <div className="form-floating form-section-col">
                                                <input type="email" className="form-control border-0" name="email" placeholder="Email" onChange={handleChange} required />
                                                <label htmlFor="email">Email</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating form-section-col" style={{ position: 'relative', zIndex: 9999 }}>
                                                <PhoneInput
                                                    className="form-control border-0 mx-2 my-2"
                                                    country="gh"
                                                    value={formData.phone}
                                                    onChange={handlePhoneChange}
                                                    international
                                                    defaultCountry="GH"
                                                    withCountryCallingCode
                                                    inputStyle={{ width: '100%' }}
                                                    style={{ paddingLeft: '10px', paddingRight: '10px', paddingBottom:'10px', paddingTop: '10px' }} // Adds padding to avoid the flag overlapping the input text
                                                />
                                            </div>
                                        </div>
                                        

                                        <div className="col-md-6">
                                            <div className="form-floating form-section-col">
                                                <input type="date" className="form-control border-0" name="dob" placeholder="Date of Birth" onChange={handleChange} required />
                                                <label htmlFor="dob">Date of birth</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating form-section-col">
                                                <input 
                                                    type="text" 
                                                    className="form-control border-0" 
                                                    name="emy_code" 
                                                    placeholder="EMY Code / Username" 
                                                    required 
                                                    value={formData.emy_code}
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        checkUsername(e.target.value);
                                                    }}
                                                />
                                                <label htmlFor="emy_code">EMY ID / Username</label>
                                                {usernameStatus && (
                                                    <small style={{ color: usernameStatus.available ? 'green' : 'red' }}>
                                                        {usernameStatus.message}
                                                    </small>
                                                )}
                                            </div>
                                        </div>

                                        <div className='row my-2'>
                                            <div className="col-md-6 mx-auto">
                                                <div className="form-section-col">
                                                    <label className="form-label text-white">ID Image</label>
                                                    <input type="file" className="form-control" name="idImage" accept="image/*" onChange={handleImageUpload} required />
                                                </div>
                                            </div>
                                            {idImage && <img className='my-2' src={idImage} alt="ID Preview" width="200" />}
                                            {/* {matchError && <p style={{ color: 'red' }}>{matchError}</p>} */}
                                            {!ocrPassed? <p style={{ color: 'red' }}>{ocrMsg}</p>: null}
                                        </div>
                                        

                                        <div className="col-md-6">
                                            <div className="form-floating form-section-col">
                                                <input type="password" className="form-control border-0" name="password" placeholder="Password" onChange={handleChange} required />
                                                <label htmlFor="password">Password</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating form-section-col">
                                                <input type="password" className="form-control border-0" name="password_confirmation" placeholder="Confirm Password" onChange={handleChange} required />
                                                <label htmlFor="password_confirmation">Confirm Password</label>
                                            </div>
                                        </div>


                                        <div className="col-12">
                                            <div className="form-section-col">
                                                <button type="submit" className="btn-primary w-100 py-3 px-5">Register</button>
                                            </div>
                                        </div>


                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}
